export default __webpack_public_path__ + "static/media/icon_cb_29.4d085401.png";